import { createContext } from "react";
import type { OperationState } from "@/lib/ops/operationState";
import type { HealthSnapshot } from "@/lib/observability/health";

export interface EngineSnapshot {
  state?: string;
  locationId?: string | null;
  locationName?: string | null;
  destinationsCount?: number;
  campaignId?: string | null;
  campaignSeedId?: string | null;
  campaignSeedTitle?: string | null;
  knownLocations?: string[];
  storyFlags?: string[];
  activeQuests?: string[];
  travel?: {
    currentLocationId: string | null;
    isInTransit: boolean;
    transitProgress: number;
  };
  combatState?: string | null;
  syncState?: "live" | "degraded" | "stale" | null;
  syncReason?: string | null;
  lastCommittedTurnId?: string | null;
  lastCommittedTurnIndex?: number | null;
  lastDmTurnId?: string | null;
  lastDmTurnIndex?: number | null;
  lastSceneCacheUpdate?: string | null;
  lastActionChipRender?: string | null;
  lastRewardTurnId?: string | null;
  lastRewardSource?: "story" | "combat" | null;
  lastRewardXp?: number | null;
  lastRewardCoins?: number | null;
  lastRewardLoot?: string[];
  lastPointsSpendStatus?: "ok" | "error" | null;
  lastPointsSpendMessage?: string | null;
  lastPointsSpendAt?: string | null;
  presentationMode?: "narration_console" | null;
  renderer?: "dom" | "pixi" | null;
  directorMode?: "player_command_dm_control" | "manual" | null;
  turnOwner?: "player" | "enemy" | "none" | null;
  lastAutoSource?: "enemy_auto" | "player_timeout_auto_attack" | "player_typed" | null;
  playerIdleTimeoutTriggered?: boolean;
  lastOverrideAt?: string | null;
  queueGeneration?: number | null;
  autoContinueApplied?: boolean;
}

export interface DiagnosticsState {
  lastError: string | null;
  lastErrorAt: number | null;
  setLastError: (message: string | null) => void;
  errorHistory: Array<{ message: string; at: number }>;
  engineSnapshot: EngineSnapshot | null;
  setEngineSnapshot: (snapshot: EngineSnapshot | null) => void;
  operations: OperationState[];
  recordOperation: (operation: OperationState) => void;
  healthChecks: Record<string, HealthSnapshot>;
  exportDebugBundle: () => string;
}

export const DiagnosticsContext = createContext<DiagnosticsState | null>(null);
